export default __webpack_public_path__ + "static/media/aone.ef36ecea.svg";